import React from 'react'
import classNames from 'classnames'
import { PaymentMethod } from '@dustin-web/microsite-config'
import Icon from '@dustin-web/microsite-components/src/icon'
import Image from '@dustin-web/microsite-components/src/image'

const paymentMethods = {
  klarna: {
    src: 'https://media.dustin.eu/content/88621/klarna.svg',
    width: 64,
    height: 28,
  },
  mc: {
    src: 'https://media.dustin.eu/content/88622/mc.svg',
    width: 45,
    height: 32,
  },
  visa: {
    src: 'https://media.dustin.eu/content/88631/visa.svg',
    width: 62,
    height: 20,
  },
  trustly: {
    src: 'https://media.dustin.eu/content/88626/trustly.svg',
    width: 60,
    height: 20,
  },
  swish: {
    src: 'https://media.dustin.eu/content/88625/swish.svg',
    width: 71,
    height: 22,
  },
  visadankort: {
    src: 'https://media.dustin.eu/content/88628/visadankort.svg',
    width: 42,
    height: 28,
  },
  ideal: {
    src: 'https://media.dustin.eu/content/88629/ideal.svg',
    width: 38,
    height: 37,
  },
  ebanking_FI: {
    src: 'https://media.dustin.eu/content/88630/paytrail.svg',
    width: 34,
    height: 34,
  },
  mobilepay: {
    src: 'https://media.dustin.eu/content/znppu0sb/mobilepay.svg',
    width: 68,
    height: 24,
  },
  invoice: {
    src: '',
    width: 0,
    height: 0,
  },
} as { [id in PaymentMethod['id']]: { src: string; width: number; height: number } }

type PaymentMethodDisplayProps = {
  className?: string
  item: PaymentMethod
  translate: (key: string) => string
}

export const PaymentMethodIcon = ({ item, className, translate }: PaymentMethodDisplayProps) => {
  if (item.type === 'invoice') {
    return (
      <div
        className={classNames(
          'invoice-box u-mb-8 u-mb-sm-0 d-inline-flex u-bg-transparent',
          className
        )}>
        <Icon
          name="document-license"
          className="u-color-gray-02 i-16 u-mr-4"
          style={{ fill: '#FFFFFF', marginTop: '2px' }}
        />
        <div className="u-fs-16 u-color-white">{translate('Invoice')}</div>
      </div>
    )
  }

  const attrs = paymentMethods[item.id]
  return attrs ? (
    <div className={classNames('u-mb-8 u-mb-sm-0', className)}>
      <Image {...attrs} alt={item.displayName} />
    </div>
  ) : null
}
